import ptCoreClient from 'plant-core-client';
import {
	ACTION_GET_ALL_PERMISSIONS,
	GETTER_ALL_PERMISSIONS,
	GETTER_PERMISSIONS_BY_CATEGORY,
	MUTATION_SET_ALL_PERMISSIONS,
	MUTATION_SET_PERMISSIONS_BY_CATEGORY,
	STATE_ALL_PERMISSONS,
	STATE_PERMISSIONS_BY_CATEGORY,
	STORE_PERMISSIONS_NAME
} from '@/store_constants/permissions';
import { convertPermissionsListToMap } from '@/utils/userPermissionsControl';

export default {
	name: STORE_PERMISSIONS_NAME,
	namespaced: true,
	state: {
		[STATE_ALL_PERMISSONS]: null,
		[STATE_PERMISSIONS_BY_CATEGORY]: null
	},
	getters: {
		[GETTER_ALL_PERMISSIONS](state) {
			return state[STATE_ALL_PERMISSONS];
		},
		[GETTER_PERMISSIONS_BY_CATEGORY](state) {
			return state[STATE_PERMISSIONS_BY_CATEGORY];
		}
	},
	mutations: {
		[MUTATION_SET_ALL_PERMISSIONS](state, permissions) {
			state[STATE_ALL_PERMISSONS] = permissions;
		},
		[MUTATION_SET_PERMISSIONS_BY_CATEGORY](state, permissions) {
			state[STATE_PERMISSIONS_BY_CATEGORY] = convertPermissionsListToMap(permissions);
		}
	},
	actions: {
		[ACTION_GET_ALL_PERMISSIONS]({ commit, dispatch }) {
			return ptCoreClient
				.getPermissions()
				.then(res => {
					const permissions = res;
					commit(MUTATION_SET_ALL_PERMISSIONS, permissions);
					commit(MUTATION_SET_PERMISSIONS_BY_CATEGORY, permissions);
				})
				.catch(error => {
					const errorStatus = error.response.status;

					if (errorStatus !== 401) {
						dispatch(
							'notifications/error',
							{ message: 'An error occurred while trying to get permissions' },
							{ root: true }
						);
					}

					return error;
				});
		}
	}
};
